var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderOnw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1161,
    height: 1519,
    viewBox: "0 0 1161 1519",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1179 1518.5H576C567.163 1518.5 560 1511.34 560 1502.5V1122.5C560 1113.66 552.837 1106.5 544 1106.5H17C8.16346 1106.5 1 1099.34 1 1090.5V-18",
    stroke: "black",
    strokeDasharray: "7 7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderOnw);
export default __webpack_public_path__ + "static/media/borderOnw.f7a65d231fc373f2f3a7ff8407eda487.svg";
export { ForwardRef as ReactComponent };